// extracted by mini-css-extract-plugin
export var base = "_3s-0";
export var updateBanner = "_3s-1";